<h4 mat-dialog-title style="margin: 0; padding-left: 50px">{{ title }}</h4>


<mat-dialog-content *ngIf="centerDetail && theme" class="previewContent">

  <div *ngIf="isLoading">
    <div
      style="position: fixed; z-index: 900; width: 100vw; height: 100vh; opacity: 80; top: 0; left: 0; background: #e8e8e880;">
    </div>
    <mat-spinner class="spinner-center" style="z-index: 1000;"></mat-spinner>
  </div>
  

  <lifedi-learning-center-content
    [centerDetail]="centerDetail"
    [theme]="theme"
  ></lifedi-learning-center-content>
</mat-dialog-content>
<mat-dialog-actions align="center">

  <button id="back-button" mat-stroked-button [mat-dialog-close]="true">
    ย้อนกลับเพื่อแก้ไข
  </button>
  <button id="save-button" mat-button class="lifedi-btn-primary" (click)="onSubmit(false)">
    บันทึก
  </button>
  <button id="save-public-button" mat-button class="lifedi-btn-success" (click)="onSubmit(true)">
    บันทึกและเผยแพร่
  </button>
</mat-dialog-actions>

